import React from "react";
import { useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";

const CallbackModal = ({ onClose }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    location: "",
    type: "Call",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);

    if (!form.name || !form.phone) {
      return toast.error("Name and Phone number are required");
    }

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/lead/create-lead`,
      maxBodyLength: Infinity,
      data: form,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("Response of handleSubmit(Lead): ", response.data);
        toast.success("Your query recorded. We'll reach you out soon.");
        onClose();
      })
      .catch((error) => {
        // console.log("Error in handleSubmit: ", error);
        toast.error("Something went wrong. Please try again later.");
      });
  };
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative h-auto md:h-[95%] lg:h-auto overflow-y-scroll md:overflow-y-auto bg-[#014A8A] rounded-lg shadow-lg md:w-full max-w-xl flex flex-col justify-center p-4 md:px-8 w-[90%]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-[#004B8B] p-4 md:p-8 flex-1">
          <h1 className="text-2xl text-white tracking-wide text-center font-bold">
            Request For Callback
          </h1>
          <p className="text-white text-center text-sm">
            Give Credential for more smooth processing.
          </p>
          <div className="flex flex-col gap-2 md:mt-8">
            <label
              htmlFor=""
              className="text-white font-semibold text-md md:text-lg tracking-wide"
            >
              Name
            </label>
            <input
              type="text"
              className="px-4 py-2 md:py-3 bg-white/20 border border-white outline-none rounded-lg text-white"
              placeholder="Enter your name"
              value={form.name}
              onChange={(e) =>
                setForm({
                  ...form,
                  name: e.target.value,
                })
              }
            />
          </div>

          <div className="flex flex-col gap-2 mt-4 md:mt-8">
            <label
              htmlFor=""
              className="text-white font-semibold text-md md:text-lg tracking-wide"
            >
              Mobile No
            </label>
            <input
              type="text"
              className="px-4 py-2 md:py-3 bg-white/20 border border-white outline-none rounded-lg text-white"
              placeholder="Mobile Number"
              value={form.phone}
              onChange={(e) =>
                setForm({
                  ...form,
                  phone: e.target.value,
                })
              }
            />
          </div>

          <div className="flex flex-col gap-2  mt-4  md:mt-8">
            <label
              htmlFor=""
              className="text-white font-semibold text-md md:text-lg tracking-wide"
            >
              Location
            </label>
            <input
              type="text"
              className="px-4 py-2 md:py-3 bg-white/20 border border-white outline-none rounded-lg text-white"
              placeholder="Location"
              value={form.location}
              onChange={(e) =>
                setForm({
                  ...form,
                  location: e.target.value,
                })
              }
            />
          </div>

          <button
            className="bg-white text-lg p-2 w-full rounded  text-center mt-6 md:mt-10 font-semibold text-[#0465B9] shadow-xl"
            onClick={handleSubmit}
          >
            {loading ? "Requesting..." : "Request Callback"}
          </button>

          <IoMdCloseCircle
            className="absolute top-2 right-2 text-white cursor-pointer"
            size={32}
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default CallbackModal;
